import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { EducationalAdvisorBatchStudio } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const retrieveEducationalAdvisorBatchStudios = createAsyncThunk<
  EducationalAdvisorBatchStudio[],
  void,
  { extra: Partial<Dependencies> }
>("educationalAdvisor/retrieve-batch-studios", async (_: void, { extra: { educationalAdvisorRepository } }) => {
  return educationalAdvisorRepository!.listBatchStudios();
});
